import React from 'react'
import AcoesPedido from './AcoesPedido';
import DetalhesPedido from './DetalhesPedido';
import ReactTooltip from 'react-tooltip';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import { validaPerfis } from '../../security/Autorizacao';
import { PERFIL_ADMIN } from '../../security/securityContext';

export class Pedido extends React.Component {
  getPedidoBadgeClass(situacao) {
    if (!situacao) return 'vx-gp-badge--default';
    const s = situacao.toUpperCase();
    if (s.includes('APROVADO') || s.includes('CONFIRMADO') || s.includes('PAGO')) return 'vx-gp-badge--aprovado';
    if (s.includes('CANCELADO') || s.includes('RECUSADO')) return 'vx-gp-badge--cancelado';
    if (s.includes('PENDENTE') || s.includes('ABERTO') || s.includes('AGUARDANDO')) return 'vx-gp-badge--pendente';
    return 'vx-gp-badge--default';
  }

  copyLink(event) {
    event.preventDefault();
    navigator.clipboard.writeText(this.props.pedido.codigoTransacao);

  }

  groupArrayOfObjects (list, key) {
    return list.reduce((rv, x) => {
      // eslint-disable-next-line no-param-reassign
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  }

  exibirTextoIdaVolta () {
    if (Object.entries(this.groupArrayOfObjects(this.props.pedido.reservas, 'itinerarioId')).length > 1) {
      return  <a title='Passagem de ida e volta' className="idaVolta" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicao(this.props.pedido)}>
         Ida/Volta</a>
     }
     return  <a title='Passagem de ida' className="ida" style={{ cursor: 'pointer' }} onClick={() => this.props.alterarExibicao(this.props.pedido)}>
       Ida</a>
  }

  recuperaFormaPagamento () {
    let labelCartao = ''
    const linkPagamento = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Link Pagamento').length > 0;
    const cieloEcommercePix = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Cielo Pix').length > 0;
    const sicoobPix = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Sicoob PIX').length > 0;
    const stonePix = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Stone Connect').length > 0;
    let cartao = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Cartão').length > 0;    
    const cartaoCredito = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Cartão de crédito').length > 0;
    const cartaoDebito = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Cartão de débito').length > 0;
    const tef = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'TEF').length > 0;    
    cartao = cartao || cartaoCredito || cartaoDebito || tef
    
    if (cartao) {
      labelCartao = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Cartão' || it.tipo === 'Cartão de crédito' || it.tipo === 'Cartão de débito' || it.tipo === 'TEF')[0].tipo
      if (labelCartao === 'TEF') {
        labelCartao = 'Cartão/TEF'
      }
    }

    const dinheiro = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'Dinheiro').length > 0;
    const pix = this.props.pedido.formasPagamentoDto.filter(it => it.tipo === 'PIX').length > 0;

    if (cartao && dinheiro && pix) {
      return `${labelCartao}, Dinheiro e PIX`;
    }
    if (cartao && dinheiro) {
      return `${labelCartao} e dinheiro`;
    }
    if (cartao && pix) {
      return `${labelCartao} e PIX`;
    }
    if (dinheiro && pix) {
      return 'Dinheiro e PIX';
    }
    if (dinheiro) {
      return 'Dinheiro'
    }
    if (cartao) {
      return labelCartao
    }

    if (pix) {
      return 'PIX'
    }

    if (linkPagamento) {
      return 'Link Pagamento'
    }

    if (cieloEcommercePix) {
      return 'Cielo Pix'
    }

    if (sicoobPix) {
      return 'Sicoob PIX'
    }

    if (stonePix) {
      return 'Stone Connect'
    }

    return 'Não informado'
  }

  exibirIconeSituacaoReserva (pedido) {
    return (
      <span className="vx-gp-tooltip-trigger">
        <a data-tip data-for={`situacao-reserva-${pedido.id}`}>
          <i className="material-icons">info</i>
        </a>
        <ReactTooltip id={`situacao-reserva-${pedido.id}`} type="dark" effect="solid">
          Situação(ões): {this.situacoesReservas()}
        </ReactTooltip>
      </span>
    )
  }

  exibirIconeCodigoPagamento (pedido) {
    if(!pedido.codigoTransacao)
      return ''
    return (
      <span className="vx-gp-tooltip-trigger" onClick={(e) => this.copyLink(e)} title="Clique para copiar o código">
        <a data-tip data-for={pedido.codigoTransacao}>
          <i className="material-icons">content_copy</i>
        </a>
        <ReactTooltip id={pedido.codigoTransacao} type="dark" effect="solid">
          <div>{pedido.codigoTransacao}</div>
          <div style={{color: '#fa8d42', fontSize: '11px', marginTop: 3}}>Clique para copiar o código</div>
        </ReactTooltip>
      </span>
    )
  }

  exibirIconeIdaVoltaPedido (pedido) {
    const ehIdaVolta = Object.entries(this.groupArrayOfObjects(this.props.pedido.reservas, 'itinerarioId')).length > 1;
    return (
      <span className="vx-gp-tooltip-trigger">
        <a data-tip data-for={`data-embarque-${pedido.id}`}>
          <i className="material-icons">{ehIdaVolta ? 'sync_alt' : 'arrow_forward'}</i>
        </a>
        <ReactTooltip id={`data-embarque-${pedido.id}`} type="dark" effect="solid">
          <div>Ida: {this.exibeDataHoraPartida(pedido, 'IDA', ehIdaVolta)}</div>
          {ehIdaVolta && <div>Volta: {this.exibeDataHoraPartida(pedido, 'VOLTA', ehIdaVolta)}</div>}
        </ReactTooltip>
      </span>
    )
  }

  exibirIconeNomeAgencia (pedido) {
    if(!pedido.nomeAgencia){
      return ''
    }
    return (
      <span className="vx-gp-tooltip-trigger">
        <a data-tip data-for={`nome-agencia-${pedido.id}`}>
          <i className="material-icons">store</i>
        </a>
        <ReactTooltip id={`nome-agencia-${pedido.id}`} type="dark" effect="solid">
          Agência: {pedido.nomeAgencia}
        </ReactTooltip>
      </span>
    )
  }

  exibeDataHoraPartida(pedido, tipo, ehIdaVolta) {
    var datas = null;
    var reservas = null;

    if(ehIdaVolta) {
      reservas = this.groupArrayOfObjects(pedido.reservas, 'dataHoraPartida')
      datas = Object.keys(reservas);

      var dataVolta = null;
      var dataIda = null;

      for(let i = 0; i < datas.length; i++) {
        datas.map((data) => {
          if(datas[i] > data) {
            dataVolta = datas[i]
          }
          if(datas[i] < data) {
            dataIda = datas[i]
          }
        })
      }

      if(tipo === 'IDA') {
        return dataIda;
      }

      if(tipo === 'VOLTA') {
        return dataVolta;
      }
    }

    if(!ehIdaVolta) {
      reservas = pedido.reservas

      reservas.forEach((it) => {
        datas = it.dataHoraPartida
      })

      return datas;
    }
  }

  situacoesReservas(){
    let situacoes = ''
    this.props.pedido.reservas.forEach((reserva,index) =>{
      situacoes += `${index > 0?  ' | ' : ''} ${capitalizarTodasPrimeirasLetras(reserva.situacaoReserva.replace('_',' '))}`
    })
    return situacoes
  }

  render () {
    const { pedido } = this.props;
    const isAdmin = validaPerfis([PERFIL_ADMIN]);
    const isOpen = pedido.exibirDetalhe;

    return (
      <div className={`vx-gp-row${isOpen ? ' vx-gp-row--open' : ''}`}>
        <div className="vx-gp-row-main" onClick={() => this.props.alterarExibicao(pedido)}>

          <div className="vx-gp-toggle">
            <span className="material-icons">{isOpen ? 'expand_less' : 'expand_more'}</span>
          </div>

          {isAdmin ? (
            <div className="vx-gp-field">
              <span className="vx-gp-field-label">Empresa</span>
              <span className="vx-gp-field-value">{pedido.nomeFantasiaEmpresa}</span>
            </div>
          ) : (
            <div className="vx-gp-field">
              <span className="vx-gp-field-label">Pedido</span>
              <span className="vx-gp-field-value">#{pedido.id}</span>
            </div>
          )}

          {isAdmin ? (
            <div className="vx-gp-field">
              <span className="vx-gp-field-label">Pedido</span>
              <span className="vx-gp-field-value">#{pedido.id}</span>
            </div>
          ) : (
            <div className="vx-gp-field">
              <span className="vx-gp-field-label">Vendedor</span>
              <span className="vx-gp-field-value">
                {pedido.nomeVendedor}
                {this.exibirIconeNomeAgencia(pedido)}
              </span>
            </div>
          )}

          {isAdmin ? (
            <div className="vx-gp-field">
              <span className="vx-gp-field-label">Vendedor</span>
              <span className="vx-gp-field-value">
                {pedido.nomeVendedor}
                {this.exibirIconeNomeAgencia(pedido)}
              </span>
            </div>
          ) : (
            <div className="vx-gp-field">
              <span className="vx-gp-field-label">Cliente</span>
              <span className="vx-gp-field-value">{pedido.nomeComprador}</span>
            </div>
          )}

          {isAdmin ? (
            <div className="vx-gp-field">
              <span className="vx-gp-field-label">Cliente</span>
              <span className="vx-gp-field-value">{pedido.nomeComprador}</span>
            </div>
          ) : (
            <div className="vx-gp-field">
              <span className="vx-gp-field-label">Data</span>
              <span className="vx-gp-field-value">{pedido.data}</span>
            </div>
          )}

          {isAdmin ? (
            <div className="vx-gp-field">
              <span className="vx-gp-field-label">Data</span>
              <span className="vx-gp-field-value">{pedido.data}</span>
            </div>
          ) : (
            <div className="vx-gp-field">
              <span className="vx-gp-field-label">Situação</span>
              <span className={`vx-gp-badge ${this.getPedidoBadgeClass(pedido.situacaoPedido)}`}>
                {pedido.situacaoPedido}
              </span>
              {this.exibirIconeSituacaoReserva(pedido)}
            </div>
          )}

          {isAdmin ? (
            <div className="vx-gp-field">
              <span className="vx-gp-field-label">Situação</span>
              <span className={`vx-gp-badge ${this.getPedidoBadgeClass(pedido.situacaoPedido)}`}>
                {pedido.situacaoPedido}
              </span>
              {this.exibirIconeSituacaoReserva(pedido)}
            </div>
          ) : (
            <div className="vx-gp-field vx-gp-field--price">
              <span className="vx-gp-field-label">Valor</span>
              <span className="vx-gp-field-value">
                {Number(pedido.valorTotalReservas).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
              </span>
            </div>
          )}

          {isAdmin ? (
            <div className="vx-gp-field vx-gp-field--price">
              <span className="vx-gp-field-label">Valor</span>
              <span className="vx-gp-field-value">
                {Number(pedido.valorTotalReservas).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
              </span>
            </div>
          ) : (
            <div className="vx-gp-field">
              <span className="vx-gp-field-label">Pagamento</span>
              <span className="vx-gp-field-value">
                {this.recuperaFormaPagamento()}
                {this.exibirIconeCodigoPagamento(pedido)}
              </span>
            </div>
          )}

          {isAdmin ? (
            <div className="vx-gp-field">
              <span className="vx-gp-field-label">Pagamento</span>
              <span className="vx-gp-field-value">
                {this.recuperaFormaPagamento()}
                {this.exibirIconeCodigoPagamento(pedido)}
              </span>
            </div>
          ) : (
            <div className="vx-gp-field">
              <span className="vx-gp-field-label">Ida/Volta</span>
              <span className="vx-gp-field-value">
                {this.exibirTextoIdaVolta()}
                {this.exibirIconeIdaVoltaPedido(pedido)}
              </span>
            </div>
          )}

          <div className="vx-gp-field--actions" onClick={e => e.stopPropagation()}>
            <AcoesPedido pedido={pedido}
                         empresaSelecionada={this.props.empresaSelecionada}
                         valoresDdiPassageiro={this.props.valoresDdiPassageiro}
                         usuarioBloqueadoEdicaoReimpressaoCupom={this.props.usuarioBloqueadoEdicaoReimpressaoCupom}
                         adicionarValoresDdiPassageiro={this.props.adicionarValoresDdiPassageiro.bind(this)}
                         removerValoresDdiPassageiro={this.props.removerValoresDdiPassageiro.bind(this)}
                         limparValoresDdiPassageiro={this.props.limparValoresDdiPassageiro.bind(this)} />
          </div>

        </div>
        <DetalhesPedido pedido={pedido}/>
      </div>
    )
  }
}


export default (Pedido)
